"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("./Button.style"));
var _LinkButton = _interopRequireDefault(require("./LinkButton"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _excluded = ["action", "disabled", "id", "children", "capitalization", "fullWidth", "href", "type", "loading", "loadingContent", "medium", "icon"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Button = function Button(_ref) {
  var action = _ref.action,
    disabled = _ref.disabled,
    id = _ref.id,
    children = _ref.children,
    capitalization = _ref.capitalization,
    fullWidth = _ref.fullWidth,
    href = _ref.href,
    type = _ref.type,
    loading = _ref.loading,
    loadingContent = _ref.loadingContent,
    medium = _ref.medium,
    icon = _ref.icon,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Component = _Button["default"];
  var componentProperties = {
    variant: type,
    medium: medium,
    disabled: disabled || loading,
    id: id,
    capitalization: capitalization,
    fullWidth: fullWidth
  };
  if (href) {
    Component = _LinkButton["default"];
    componentProperties = _objectSpread({
      href: href
    }, componentProperties);
  }
  var clickHandler = function clickHandler(e) {
    if (typeof action === 'function') action(e);
  };
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, otherProps, componentProperties, {
    onClick: clickHandler
  }), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "button-icon",
    size: otherProps.iconSize || 24,
    icon: icon
  }), loading ? loadingContent : children);
};
Button.defaultProps = {
  action: undefined,
  disabled: false,
  href: undefined,
  loading: false,
  loadingContent: undefined,
  medium: false,
  type: 'primary',
  icon: undefined,
  id: undefined,
  fullWidth: false,
  capitalization: 'capitalize',
  children: null
};
Button.propTypes = {
  /** Action triggered by clicking the button */
  action: _propTypes["default"].func,
  /** Control the capitalization of button text based on css text-transform property */
  capitalization: _propTypes["default"].oneOf(['lowercase', 'capitalize', 'uppercase', 'none', 'inherit']),
  /** Text or html to be displayed inside the button */
  children: _propTypes["default"].node,
  /** Flag to disable the button */
  disabled: _propTypes["default"].bool,
  /** Extend button to full width of the container */
  fullWidth: _propTypes["default"].bool,
  /** A link to navigate to. If provided a link will be rendered. */
  href: _propTypes["default"].string,
  /** Icon class to be inserted inside the button */
  icon: _propTypes["default"].string,
  /** Button id */
  id: _propTypes["default"].string,
  /** Flag to indicate an ongoing action */
  loading: _propTypes["default"].bool,
  /** Node to display while loading */
  loadingContent: _propTypes["default"].node,
  /** Flag for medium button */
  medium: _propTypes["default"].bool,
  /** Button variant */
  type: _propTypes["default"].oneOf(['primary', 'naked', 'link'])
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Button);